// @ts-ignore
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
import { RbFragmentDoc } from '../../graphql/api/ring-builder/rb.fragment.generated';
import { MeFragmentDoc } from '../../graphql/api/fragments/me.fragment.generated';
import { TranslationFragmentDoc } from '../../graphql/api/fragments/translation.fragment.generated';
import { TopBarFragmentDoc } from '../../components/layout/header/menu/api/TopBar.fragment.generated';
import { PreHeaderFragmentDoc } from '../../components/layout/header/menu/api/PreHeader.fragment.generated';
import { HeaderMenuFragmentDoc } from '../../components/layout/header/menu/api/HeaderMenu.fragment.generated';
import { SocialNetworkFragmentDoc } from '../../graphql/api/fragments/socialNetworks.fragment.generated';
import { PaymentIconFragmentDoc } from '../../graphql/api/fragments/paymentIcon.fragment.generated';
import { FooterFragmentDoc } from '../../components/layout/footer/Footer.fragment.generated';
import { AvatarStackItemFragmentDoc } from '../../components/layout/avatar-stack/AvatarStackItem.fragment.generated';
import * as Urql from '@urql/vue';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export const AlternateTagFragmentDoc = gql`
    fragment alternateTag on Region {
  __typename
  code
  locales
}
    `;
export const RegionPluginFragmentDoc = gql`
    fragment regionPlugin on Region {
  code
  isActive
  currency
  language {
    locale
  }
}
    `;
export const InitDocument = gql`
    query init($locale: Locale!, $currency: CurrencyInput!, $region: RegionCode!, $fetchRegionSuggest: Boolean!, $isConsultant: Boolean!) {
  ringBuilder(input: {region: $region, currency: $currency}) {
    ...rb
  }
  me {
    ...me
  }
  workingHours(locale: $locale) {
    weekDays
    opening
    closing
  }
  regionSuggest @include(if: $fetchRegionSuggest) {
    code
  }
  defaultAlternateRegion {
    ...alternateTag
  }
  regions {
    ...alternateTag
    ...regionPlugin
  }
  language(locale: $locale) {
    locale
    translations {
      ...translation
    }
  }
  topBar(locale: $locale) {
    ...topBar
  }
  preHeader(locale: $locale) {
    ...preHeader
  }
  mainMenu(locale: $locale) {
    ...headerMenu
  }
  socialNetworks(locale: $locale) {
    ...socialNetwork
  }
  paymentIcons(locale: $locale) {
    ...paymentIcon
  }
  footer(locale: $locale) {
    ...footer
  }
  avatarStack(locale: $locale) {
    ...avatarStackItem
  }
}
    ${RbFragmentDoc}
${MeFragmentDoc}
${AlternateTagFragmentDoc}
${RegionPluginFragmentDoc}
${TranslationFragmentDoc}
${TopBarFragmentDoc}
${PreHeaderFragmentDoc}
${HeaderMenuFragmentDoc}
${SocialNetworkFragmentDoc}
${PaymentIconFragmentDoc}
${FooterFragmentDoc}
${AvatarStackItemFragmentDoc}`;

export function useInitQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.InitQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.InitQuery, SchemaTypes.InitQueryVariables | undefined>({ query: InitDocument, variables: undefined, ...options });
};